<template>
    <div class="modal" >
        <div class="modal-content">
            <div class="modal-header">
               Bestel rapport  <button class="btn btn-info btn-sm" @click="closeModal">X</button>
            </div>
  
            <div class="modal-body">

                <div class="alert_container" style="text-align: center">
                    <div v-if="message" class="alert alert-warning alert_1">{{message}}</div>
                </div>

                <form @submit.prevent="parseForm">
               
                    Vul je e-mailadres twee keer in en klik op de bestelknop. Je wordt vervolgens doorgestuurd naar
                    de payment service provider waar je je betaling kan doen. Zodra je betaling is geslaagd, 
                    ontvang je op het opgegeven e-mailadres een mail met het rapport. 
                    Het rapport is als bijlage in PDF-formaat gehecht aan de e-mail.
                    <br><br>
              
                    <div class="form-group" style="text-align: left">
                        <label for="titel" class="titel" >E-mailadres:</label>
                        <input class="form-control" type="email" placeholder="" v-model="email" />     
                    </div>

                     <div class="form-group" style="text-align: left">
                        <label for="titel" class="titel" >E-mailadres (controle):</label>
                        <input class="form-control" type="email" placeholder="" v-model="emailcontrole" />     
                    </div>
                    
                    <div class="form-group order"  style="text-align: right" >
                        <button type="submit" class="btn btn-primary btn-lg" >bestel</button>
                    </div>

              </form>
            </div>
            
           
        </div>
    </div>
</template>


<script>
//https://www.genuitec.com/beginners-guide-to-vue-modals/

//https://dev.to/fullstackmafia/creating-a-basic-online-payment-flow-with-rave-and-vue-3f72
//https://stackoverflow.com/questions/45578844/how-to-set-header-and-options-in-axios

import axios from "axios";

export default {
    name: 'app-modal',

    props: {
        showModal: Boolean,
        result_id: Number, //wordt in parent doorgegeven met: v-bind:result_id="result.id" //this.result_id
        amount: Number,
    },

    data() {
        return {
            email:'',
            emailcontrole:'',
            message: '',
            price_report:process.env.VUE_APP_PRICE_REPORT
        };
    },

    methods: {
        closeModal() {
            this.$emit('clicked');
        },

        parseForm(){
            var valid=this.validEmail(this.email)
            if (valid==true) {
                 this.sameEmail()
                }
            else {
                 this.message="Het e-mailadres heeft niet het juiste formaat.";
            }
        },

        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        sameEmail(){
            if(this.email==this.emailcontrole){
                this.handlePayment();
            }
            else{
                this.message="De e-mailadressen zijn niet hetzelfde.";
            }

        },

        handlePayment(){
            axios.post(process.env.VUE_APP_URL_MAKEPAYMENT, {
                id: this.result_id,
                email: this.email,
                amount: this.price_report
            })
            .then(response => {
                //redirect met de url die Mollie heeft gestuurd en in de response binnenkomt
                var url=response.data.redirect_url;
                window.location.href = url;
                //console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            })
        },

    },

  };
</script>


<style>
    .modal {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 700px;
        max-width: 100%;
        height:600px;
        min-height: 550px;

        background: #FFF;
        overflow-x: auto;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
    }
    .modal-header{
       color:#fff;
       font-size:1.5em;
       background-color:#65676D;
    }
    .modal-body{
        color:#000;
        text-align:left;
    

    }
    .modal-content{
        border-top:0px;
        border-bottom:0px;
    }
    .order{
        position:relative;
        margin-top: 2em;

    }


</style>